import { ReactNode } from "react";

import { Button, Icon_ShaprLogo, Link } from "@shapr3d/frontend-lib";

import { eduLicenseEligibilityURL } from "../../config";
import useNavigation from "../../hooks/navigation";
import useTranslation from "../../hooks/useTranslation";
import Heading from "../Heading/Heading";

import style from "./InvalidEduRequest.module.css";

export enum InvalidEduRequestType {
  IneligibleEmail,
  Unavailable,
  EmailVerificationRequired,
}

export interface InvalidEduRequestProps {
  type: InvalidEduRequestType;
}

export const InvalidEduRequest = (props: InvalidEduRequestProps) => {
  const { goToSubscription } = useNavigation();
  const { t, m } = useTranslation();

  const eligibilityLinkValues = {
    link: (chunks: ReactNode) => (
      <Link href={eduLicenseEligibilityURL} target="_blank">
        {chunks}
      </Link>
    ),
  };

  const content = {
    [InvalidEduRequestType.IneligibleEmail]: {
      title: t(m.InvalidEduRequest.IneligibleEmailTitle),
      text: (
        <>
          <p>{t(m.InvalidEduRequest.IneligibleEmailText)}</p>
          {t(m.InvalidEduRequest.IneligibleEmailCheckEligibility, eligibilityLinkValues)}
        </>
      ),
      buttonText: t(m.InvalidEduRequest.IneligibleEmailButton),
    },
    [InvalidEduRequestType.Unavailable]: {
      title: t(m.InvalidEduRequest.UnavailableTitle),
      text: t(m.InvalidEduRequest.UnavailableText),
      buttonText: t(m.InvalidEduRequest.UnavailableButton),
    },
    [InvalidEduRequestType.EmailVerificationRequired]: {
      title: t(m.InvalidEduRequest.EmailVerificationTitle),
      text: (
        <>
          <p>{t(m.InvalidEduRequest.EmailVerificationText)}</p>
          {t(m.InvalidEduRequest.EmailVerificationCheckEligibility, eligibilityLinkValues)}
        </>
      ),
      buttonText: t(m.InvalidEduRequest.EmailVerificationButton),
    },
  };

  return (
    <section>
      <div className={style.container}>
        <Icon_ShaprLogo height={156} />
        <Heading type="h1">{content[props.type].title}</Heading>

        <div className={style.text}>{content[props.type].text}</div>

        <Button className={style.button} onClick={() => goToSubscription()}>
          {content[props.type].buttonText}
        </Button>
      </div>
    </section>
  );
};
